module.exports = __webpack_public_path__ + "static/media/friends.bbdcd943.webp";